import React from "react";

export interface PageContainerProps {
  children: React.ReactNode;
  title?: string;
  className?: string;
  maxWidth?: "4xl" | "5xl" | "6xl" | "7xl";
  noPadding?: boolean;
  showTitleDivider?: boolean;
}

export const PageContainer: React.FC<PageContainerProps> = ({
  children,
  title,
  className = "",
  maxWidth = "5xl",
  noPadding = false,
}) => {
  const paddingClasses = noPadding ? "" : "p-6 md:p-8";
  const maxWidthClass = `max-w-${maxWidth}`;
  
  return (
    <div className={`min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 ${paddingClasses}`}>
      <div className={`${maxWidthClass} mx-auto ${className}`}>
        {title && (
          <div className="sticky top-20 bg-gradient-to-br from-slate-50 to-slate-100 z-10 text-center mb-6 py-4">
            <h2 className="text-4xl font-extralight text-slate-900 mb-4 tracking-wide">{title}</h2>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};